import { render } from "./WQlook.vue?vue&type=template&id=71b46494&scoped=true"
import script from "./WQlook.vue?vue&type=script&lang=js"
export * from "./WQlook.vue?vue&type=script&lang=js"

import "./WQlook.vue?vue&type=style&index=0&id=71b46494&lang=scss&scoped=true"
import "./WQlook.vue?vue&type=style&index=1&id=71b46494&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71b46494"]])

export default __exports__